//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'little-tip',
  data () {
    return {
      showTip: true,
      msg: '',
      type: ''
    }
  },
  mounted () {
    setTimeout(() => {
      this.showTip = false
    }, 1500)
  }
}



// WEBPACK FOOTER //
// ./src/components/toast/src/main.vue